module.exports = __webpack_public_path__ + "img/member-ad-05.ca4b4773.png";